import { useState } from "react"
import { Input } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import { useTenantNavigation } from "../../hooks/useTenantNavigation"
import { useTranslation } from "react-i18next"


const GlobalSearch = () => {
    const [searchText, setSearchText] = useState("")
    const navigate = useTenantNavigation()
    const { t } = useTranslation();

    const handleChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && searchText.trim()) {
            navigate(`/app/search?q=${encodeURIComponent(searchText)}`)
        }
    }

    return (
        <div className="global-search-container">
            <Input value={searchText} placeholder={t("Search")} suffix={<SearchOutlined />} onChange={handleChange} onKeyPress={handleKeyPress} />
        </div>
    )
}

export default GlobalSearch